module.exports = __webpack_public_path__ + "static/media/icon-user.8462f02b.svg";